import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAILeaveActions } from "./leaveAiFunction";
import { AppDispatch } from "../data/redux/store";
import { fetchEmployeeLeaveAssignById, fetchLeaveRequestByEmployeeId } from "../data/redux/attendance/leave/leaveAction";
import { getEmployeeByUserId } from "../data/redux/employee/employeeAction";
import dayjs from "dayjs";

const AIActionListener = () => {

    const dispatch = useDispatch<AppDispatch>();
    const { employeesbyUser } = useSelector((state: any) => state.employee);
    const { employeeLeaveRequest } = useSelector((state: any) => state.attendance.leaveRequests);
    const [employeeassignleave, setemployeeassignleave] = useState<any>([])
    const { user } = useSelector((state: any) => state.auth);

    const employeeId = employeesbyUser?.employeeId;

    useEffect(() => {
        if (employeeId && !employeeLeaveRequest.length) {
            dispatch(fetchLeaveRequestByEmployeeId(employeeId))
        }
        if (!employeesbyUser?.employeeId) {
            dispatch(getEmployeeByUserId({ userId: user?.UserId }));
        }
        if (employeeId) {
            dispatch(fetchEmployeeLeaveAssignById(employeeId))
                .then((res) => {
                    setemployeeassignleave(res.payload.data)
                })
        }
    }, [dispatch, employeeId, employeeLeaveRequest.length, employeesbyUser?.employeeId, user?.UserId])

    const { handleAIApplyLeave, handleAICancelLeave,handleAICancelAllLeaves } =
        useAILeaveActions(employeeId, employeeassignleave, employeeLeaveRequest);

    useEffect(() => {
        const handler = async (event: any) => {
            const { action, type, fromDate, toDate, days, ask } = event.detail;

            if (action === "apply_leave") {

                if (!type) {
                    window.dispatchEvent(new CustomEvent("ai-suggest-types", { detail: employeeassignleave }));
                    window.dispatchEvent(new CustomEvent("ai-chat", { detail: "Which leave type should I apply?" }));
                    return;
                }

                if (fromDate && toDate) {
                    await handleAIApplyLeave(type, fromDate, toDate);
                    return;
                }

                if (days) {
                    await handleAIApplyLeave(type, '', '', days);
                    return;
                }

                if (ask) {
                    window.dispatchEvent(new CustomEvent("ai-suggest-dates", {
                        detail: {
                            today: dayjs().format("YYYY-MM-DD"),
                            tomorrow: dayjs().add(1, "day").format("YYYY-MM-DD"),
                            dayAfter: dayjs().add(2, "day").format("YYYY-MM-DD"),
                            nextWeek: dayjs().add(7, "day").format("YYYY-MM-DD"),
                        }
                    }));

                    window.dispatchEvent(new CustomEvent("ai-chat", {
                        detail: "For which date(s) should I apply the leave?"
                    }));
                    return;
                }
            }

            if (action === "cancel_leave") {
                await handleAICancelLeave();
            }
            if (action === "cancel_all_leave") {
                await handleAICancelAllLeaves();
            }
        };

        window.addEventListener("ai-action", handler);
        return () => window.removeEventListener("ai-action", handler);
    }, [employeeassignleave, handleAIApplyLeave, handleAICancelAllLeaves, handleAICancelLeave]);

    return null;
};

export default AIActionListener;
